export default "__VITE_ASSET__DS7g8jD6__"